// extracted by mini-css-extract-plugin
module.exports = {"information":"Table_information__3KmJD","name":"Table_name__1Y85l","score":"Table_score__3X87j","table":"Table_table__sjKoM"};